import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box, BoxProps, Card, Grid, GridProps,
} from '@mui/material';
import { CongratulationsDescription } from './CongratulationsDescription';
import { CongratulationsActions } from './CongratulationsActions';
import { CongratulationsImage } from './CongratulationsImage';

const CongratulationsGrid = styled(Grid)<GridProps>(({ theme }) => ({
  backgroundColor: theme.palette.altBackground.main,
  height: '100%',
  padding: '50px 0',
}));

const ImageWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  marginTop: '100px',
  marginBottom: '10px',
  display: 'flex',
  justifyContent: 'center',
}));

export function Congratulations() {
  return (
    <CongratulationsGrid container alignItems="center" justifyContent="center" sx={{ backgroundColor: 'mainBackground.main' }}>
      <Grid item>
        <Card sx={{ maxWidth: 685 }}>
          <ImageWrapper>
            <CongratulationsImage />
          </ImageWrapper>
          <CongratulationsDescription />
          <CongratulationsActions />
        </Card>
      </Grid>
    </CongratulationsGrid>
  );
}
